export default "__VITE_ASSET__Cx$xwEZQ__"